import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconProgressArc: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="progress-arc, progress-dynamic, ideas, open, status, task"><path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 12L18.332 16.0186C19.0517 14.8845 19.4539 13.5779 19.4961 12.2354C19.5382 10.8929 19.2193 9.56368 18.5723 8.38672C17.9252 7.20974 16.9735 6.22863 15.8174 5.54492C14.6613 4.86123 13.3431 4.5 12 4.5V12Z" fill="currentColor"/></CentralIconBase>;
};

export default IconProgressArc;
